const CheckIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      fill="inherit"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M22.53 5.53 8.25 19.81l-6.78-6.78 1.061-1.061 5.72 5.72 13.22-13.22 1.061 1.061h-.002Z" />
    </svg>

  );
};

export default CheckIcon;
